
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import Gallery from "../pages/gallery/page";
import Contact from "../pages/contact/page";
import Proposal from "../pages/proposal/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/proposal",
    element: <Proposal />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
